module.exports = __webpack_public_path__ + "static/media/JAM.82fd55cf.svg";